/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';

import brandThemes from '../../../../../app/components/AppShell/brandtheme';
import { getFeatureFlags, getBrandConfig } from '../App/App-Selectors';
import {
    getIsDeliveryAddressFilledForAllItems,
    isDeliveryMessageAndDateFilledForAllItems,
    getIsPassportOnlyItemOnCart,
    getOrderTotalShipping,
    getPassportSubscriptionStatus,
    getOrderItemExcludePassportAndDonation,
    getOrderContainsSubscriptionItem,
    getIsDonationOnlyItemOnCart,
    getCartOrder,
    getIsContactInfoFilled,
    getBillingAddress,
} from '../../../MfeCheckout/ducks/Cart/Cart-Selectors';
import { getGooglePaymentUsingCardFromWallet } from '../../../MfeCheckout/ducks/Payment/PaymentMethods/GooglePay/GooglePay-Selectors';

// import { getWalletEntries } from '../../../Member/ducks/Common/Common-Selectors';
import {
    getPaypalPaymentDetails,
    getPaymentUsingPaypalWallet,
    getIsPaypalHasBillingDetails,
} from '../../../MfeCheckout/ducks/Payment/PaymentMethods/Paypal/Paypal-Selectors';
import { getOIErrors, getOrderItemErrors } from './ducks/Error/Error-Selector';
import ErrCodeFieldMapping from '../../../Common/ducks/Error/constant/ErrCodeMap';
import ValidationRules from '../../../../../app/pages/Checkout/containers/EnterpriseCheckout/Common/TextFieldWrapper/ValidationRules';
import { countriesProps } from '../../../../../app/pages/Checkout/containers/EnterpriseCheckout/Common/Helpers/Input-Helper';
// src/state/ducks/Checkout/ducks/Common/ducks/Error/Error-Selector.js

export const getCurrentBrandId = (state) => ({ ...{ ...state }.ui }.brandId) || '';

// Add to cart
export const getAddToCartLoaderStatus = (state) => state.addToCart.loader;
export const getAddToCartError = (state) => state.addToCart.error;

/**
 * @param {} state
 */
export const getBrandsById = (state) => {
    if (state && state.page && state.page.brands && state.page.brands.byId) {
        return state.page.brands.byId;
    }

    return null;
};

// Brand (Client Id)
/*
export const getBrand = createSelector(
    [
        getCurrentBrandId,
        getBrandsById,
    ],
    (currentBrandId, brandsById) => {
        if (currentBrandId && brandsById[currentBrandId]) {
            return brandsById[currentBrandId];
        }

        return null;
    },
);
*/

export const getBrand = (state) => {
    const brandConfig = getBrandConfig(state);
    return brandConfig;
};

/**
 * @param {} state
 */
export const getConfigByDomain = (state) => {
    if (state && state.app && state.app.config && state.app.config.byDomain) {
        return state.app.config.byDomain;
    }
    return null;
};

export const getFlags = (state) => {
    const flags = getFeatureFlags(state);
    return flags;
};

export const getLoaderStatus = (state) => state.common.showLoadingMessage.flag;
export const getLoaderId = (state) => state.common.showLoadingMessage.loaderId;

export const getOrder = (state) => state?.order;
export const getOrderId = (state) => state?.order?.orderId || '';
export const getTotalItemInCart = (state) => state?.order?.cartCount;

// Error
export const getError = (state) => state?.common?.error;
export const getPaymentError = (state) => state?.common?.error?.payment || {};
export const getCartError = (state) => state?.common?.error?.cart || '';
export const getRecipientFormError = (state) => state?.common?.error?.recipientForm;
export const getRecipientGiftMessageError = (state) => state?.common?.error?.giftMessage || {};
export const getGiftCardError = (state) => state?.common?.error?.giftCard;
export const getPromotionError = (state) => state?.common?.error?.promotion;
export const getCalendarError = (state) => state?.common?.error?.calendar;
export const getDTWError = (state) => state?.common?.error?.dtw;
export const getPmallShippingMethodError = (state) => state?.common?.error?.pmallShippingMethod || {};
export const getPayPalError = (state) => state?.common?.error?.paypal;

export const getIsPromotionHasError = (state) => {
    const promoError = getPromotionError(state);
    if (promoError?.error || promoError?.promotionCode) {
        return true;
    }
    return false;
};

export const getIsPaymentHasError = (state) => {
    const checkoutErrors = state?.checkout?.error || {};
    const cartId = state?.order?.orderId || '';
    let errorMessage = '';

    if (cartId && checkoutErrors && checkoutErrors[cartId]?.payment) {
        Object.keys(checkoutErrors[cartId]?.payment?.validationErrors || []).forEach((fieldName) => {
            if (checkoutErrors[cartId].payment[fieldName] !== '' && fieldName !== 'validateBillingAddress' && fieldName !== 'error') {
                errorMessage += `${checkoutErrors[cartId]?.payment[fieldName]} `;
            }
        });
        if (!errorMessage) {
            errorMessage = checkoutErrors[cartId]?.payment?.errorMessage;
        }
    }

    if (errorMessage !== '') {
        return true;
    }

    return false;
};

export const getIsRecipientHasError = (state) => {
    const recipientError = getOrderItemErrors(state);
    let errorMessage = '';

    Object.keys(recipientError).forEach((orderItemId) => {
        Object.keys(recipientError[orderItemId]).forEach((featureType) => {
            if (recipientError[orderItemId][featureType].errorKey) {
                errorMessage += `${recipientError[orderItemId][featureType].errorKey} `;
            }
        });
    });

    if (errorMessage !== '') {
        return true;
    }

    return false;
};

// Recipient
export const getCalShippingAttempt = (state) => state?.recipient?.calShipping?.calShippingChargesAttempt;
export const getCalShippingStatus = (state) => state?.recipient?.calShipping?.calShippingApplied;
export const getRecipientForm = (state) => state?.recipient?.recipientForm;
export const getCurrentRecipients = (state) => state?.recipient?.recipients;
export const getWorkingRecipient = (state) => state?.recipient?.workingRecipient;
export const getShippingInfo = (state) => state?.recipient?.shippingInfo;
export const getGiftMessageInfo = (state) => state?.recipient?.giftMessage;
export const getUserSubmittedProductFilterZipcode = (state) => state.ui.appContext.userSubmittedProductFilterZipcode;
export const getLocationType = (state) => state.ui.appContext.locationType;

export const getIfZipCodeIsValid = (state) => {
    const recipientFormError = getRecipientFormError(state);
    // avoid international product - zipcode is saved as 00000
    if (recipientFormError?.zipCode !== '00000' && recipientFormError?.zipCode === 'Invalid Zip Code') {
        return false;
    }
    return true;
};

// QAS Address Search
export const getQasSearchSuggestion = (state) => state.common.addressSearchQAS.suggestion;
export const getQasSearchFormattedAddress = (state) => state.common.addressSearchQAS.formattedAddress;
export const getShowValidatedAddressSuggestion = (state) => state.common.addressSearchQAS.showValidatedAddressSuggestion;
export const getHasQasFailed = (state) => state.common.addressSearchQAS.qasFailed;

// Gift Expressions
export const getGiftMessageExpressions = (state) => state.recipient.giftMessageExpressions;

// Payment
export const getPaymentDetails = (state) => state?.checkout?.payment?.paymentDetails;
export const getPaymentInfo = (state) => state?.checkout?.payment?.paymentForm;
export const getPaymentMethod = (state) => state?.checkout?.payment?.paymentForm?.paymentMethod;
export const getPaymentMethods = (state) => state?.checkout?.payment?.paymentMethods || {};
export const getApplePayStatus = (state) => state?.checkout?.payment?.paymentMethods?.ApplePay?.active;

export const getIfPayPalPaymentFailedDueToMissingAddress = createSelector(
    [
        getPaymentError,
    ],
    (paymentFailedError) => {
        if (paymentFailedError.error === 'ERROR_PAYPAL_ADDRESS') {
            return true;
        }
        return false;
    },
);

// Subscription
export const getSubscription = (state) => state.checkout.payment.subscription;
export const getEmailOptIn = (state) => state.checkout.payment.subscription.emailOptIn;
export const getSMSOptIn = (state) => state.checkout.payment.subscription.smsOptIn;
export const getOrderStatusOptIn = (state) => state.checkout.payment.subscription?.orderStatusOptIn;
export const getOptInEntryMessage = (state) => state.checkout.payment.subscription.optInEntryMessage;
export const getUserProfile = (state) => state?.account?.userProfile;

// promotion
export const getPromotionDetails = (state) => state.checkout.payment.promotion;

export const disablePaymentFields = (state) => {
    const cart = getCartOrder(state);
    const externalCartProducts = cart?.externalCart || {};
    if (Number(externalCartProducts?.orderTotal) > 0) {
        return false;
    }

    return !!(cart && cart.cartTotal && Number(cart.cartTotal) === 0);
};

export const getPlaceOrderStatus = createSelector(
    [
        getPaymentInfo,
        getBillingAddress,
        disablePaymentFields,
        getPaypalPaymentDetails,
        getPaymentUsingPaypalWallet,
        getGooglePaymentUsingCardFromWallet,
        getOIErrors,
        getOrderId,
    ],
    (
        paymentInfo,
        billingInfo,
        disablePaymentMethod,
        paypalBT,
        usePayPalWallet,
        useGooglePayWallet,
        checkoutErrors,
        cartId,
    ) => {
        const isPhoneValid = billingInfo && billingInfo.phone
            ? !ValidationRules.Phone({
                value: billingInfo.phone,
                required: true,
                min: 10,
                max: 15,
            })?.flagError
            : false;

        const isEmailValid = billingInfo && billingInfo.email
            ? !ValidationRules.Email({
                value: billingInfo.email,
                required: true,
            })?.flagError
            : false;

        const selectedCountryProps = countriesProps[billingInfo.country || 'US'];
        const isZipCodeValid = (
            billingInfo.zipCode
                ? !ValidationRules.ZipCode({
                    value: billingInfo.zipCode,
                    required: true,
                    min: selectedCountryProps?.zipCode?.min || 5,
                    max: selectedCountryProps?.zipCode?.max || 5,
                    country: billingInfo.country,
                })?.flagError
                : false
        );
        const isFilledAllInputs = billingInfo.firstName
                && billingInfo.lastName
                && billingInfo.address1
                && billingInfo.city
                && billingInfo.country;

        // Country is not US or CAN the zipcode and state is not mandatory.
        const isFilledZipState = ['US', 'USA', 'CA', 'CAN'].includes(billingInfo.country) ? (billingInfo.zipCode && billingInfo.state) : true;

        // server side errors
        const errorPayment = checkoutErrors?.[cartId]?.payment || {};

        // credit card
        if (paymentInfo?.paymentMethod?.id === 'PayPal') {
            if (paypalBT && paypalBT.payload && paypalBT.payload.nonce && billingInfo.isFormValid) { // Paypal Braintree
                return true;
            }

            if (
                usePayPalWallet
                && isPhoneValid && isEmailValid && isZipCodeValid
                && isFilledAllInputs && isFilledZipState
                && errorPayment.errorKey !== 'ZIPCODE_VALIDATION_ERROR'
            ) {
                return true;
            }
        }

        if (paymentInfo?.paymentMethod?.id === 'GooglePay' && useGooglePayWallet) {
            return true;
        }

        if (paymentInfo && billingInfo) {
            if (
                disablePaymentMethod
                && billingInfo.isFormValid && isPhoneValid
                && isEmailValid && isZipCodeValid
                && isFilledAllInputs && isFilledZipState
                && errorPayment.errorKey !== 'ZIPCODE_VALIDATION_ERROR'
            ) { // Gift Card covers order
                return true;
            }

            if (
                paymentInfo.isFormValid && billingInfo.isFormValid
                && isPhoneValid && isEmailValid && isZipCodeValid
                && isFilledAllInputs && isFilledZipState
                && errorPayment.errorKey !== 'ZIPCODE_VALIDATION_ERROR'
            ) { // Credit Card or another payments
                return true;
            }

            return false;
        }

        return false;
    },
);

export const removeMaskForPhoneNumber = (number) => {
    let strNumber = number.toString().trim();
    strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
    if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
        strNumber = strNumber.substring(2, strNumber.length);
    } else if (strNumber.indexOf('+') >= 0) {
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
    }
    return strNumber;
};

export const getIsContactInfoRequired = createSelector(
    [
        getPaymentInfo,
        getPaymentUsingPaypalWallet,
        getGooglePaymentUsingCardFromWallet,
        disablePaymentFields,
        getIsPaypalHasBillingDetails,
    ],
    (
        paymentInfo,
        usePaypalWallet,
        useGooglePayCardWallet,
        disablePaymentMethod,
        paypalBillingAddressFilled,
    ) => paymentInfo.paymentMethod.id === 'Klarna'
    || paymentInfo.paymentMethod.id === 'CreditCard'
    || (paymentInfo.paymentMethod.id === 'PayPal' && (usePaypalWallet || !paypalBillingAddressFilled))
    || (paymentInfo.paymentMethod.id === 'GooglePay' && useGooglePayCardWallet)
        || disablePaymentMethod,
);

export const getReviewOrderStatus = createSelector(
    [
        getPaymentInfo,
        getBillingAddress,
        disablePaymentFields,
        getSMSOptIn,
        getPaymentUsingPaypalWallet,
        getIsPaypalHasBillingDetails,
        getGooglePaymentUsingCardFromWallet,
        getOrderStatusOptIn,
        getOIErrors,
        getOrderId,
    ],
    (
        paymentInfo,
        billingInfo,
        disablePaymentMethod,
        smsOptIn,
        usePaypalWallet,
        paypalHasBillingAddress,
        useGooglePayCardWallet,
        orderStatusOptIn,
        checkoutErrors,
        cartId,
    ) => {
        // sms opt-in enabled
        const mobilePhone = removeMaskForPhoneNumber(billingInfo.mobilePhone);
        const phone = removeMaskForPhoneNumber(billingInfo.phone);

        if ((smsOptIn || orderStatusOptIn) && (mobilePhone.length < 10 || mobilePhone.length > 12)) {
            return false;
        }

        if (phone.length > 0 && (phone.length < 10 || phone.length > 12)) {
            return false;
        }

        // Giftcard Fully Applied & Billing Form filled
        if (disablePaymentMethod && billingInfo.isFormValid) { // Gift Card covers order
            return true;
        }

        if (['Klarna'].includes(paymentInfo.paymentMethod.id)
            && (billingInfo.country !== 'US' || !billingInfo.isFormValid)) {
            return false;
        }

        // credit card
        const errorPayment = checkoutErrors?.[cartId]?.payment || {};
        const errorCode = ErrCodeFieldMapping[errorPayment.errorKey]?.error || null;

        if (paymentInfo.paymentMethod.id === 'CreditCard'
            && paymentInfo.isFormValid
            && (
                billingInfo.phone
                && billingInfo.email
                && billingInfo.isFormValid
            )
            && (
                errorPayment.errorKey === 'VALIDATION_REQUIRED' // exception for recaptcha
                || (
                    !errorCode // there is not any error server side still pending for the user resolve
                    && errorPayment.errorKey !== 'ZIPCODE_VALIDATION_ERROR' // still is pending server side error for zipcode
                )
            )
        ) {
            return true;
        }

        // Paypal Wallet Card Or Paypal - Missing Billing Address
        if (paymentInfo.paymentMethod.id === 'PayPal'
            && ((usePaypalWallet || !paypalHasBillingAddress)
                && !billingInfo.isFormValid)) {
            return false;
        }

        // Google Pay Card From Wallet - Missing Billing Address
        if (paymentInfo.paymentMethod.id === 'GooglePay'
            && useGooglePayCardWallet
            && !billingInfo.isFormValid) {
            return false;
        }

        // all other payment methods
        if (paymentInfo.paymentMethod.id !== 'CreditCard' && !disablePaymentMethod) {
            return true;
        }

        return false;
    },
);

export const getOrderItemsWithError = (state) => {
    const paymentErrors = getPaymentError(state);
    return Object.keys(paymentErrors).filter((errorKey) => (Number(errorKey) > 0 && Number(errorKey) > 0 && paymentErrors[errorKey]));
};

// Passport
export const getPaymentMethodToPurchasePassport = () => ['CreditCard', 'PayPal'];

export const continueToPayment = createSelector(
    [
        getIsDeliveryAddressFilledForAllItems,
        isDeliveryMessageAndDateFilledForAllItems,
        getIsPassportOnlyItemOnCart,
        getIsDonationOnlyItemOnCart,
    ],
    (orderItemAddressFilled, orderItemMsgAndDateFilled, passportOnlyItemInCart, donationOnlyItemInCart) => {
        if (passportOnlyItemInCart || donationOnlyItemInCart) {
            return true;
        }
        if (orderItemAddressFilled && orderItemMsgAndDateFilled) {
            return true;
        }
        return false;
    },
);

export const continueToReview = continueToPayment && getIsContactInfoFilled;

/**
 * @param {} state
 */
// Brand Customer Care Contact
export const getCustomerCare = (state) => {
    const brandDetails = getBrand(state);
    if (brandDetails && brandDetails.phoneNumber) {
        return brandDetails.phoneNumber;
    }
    return '';
};

/**
 * @param {} state
 */
// Get Passport Feature Flag
export const getFlagEnablePassport = (state) => {
    const flags = getFlags(state);
    if (flags && Object.prototype.hasOwnProperty.call(flags, 'is-product-passport-banner-enabled')) {
        return flags['is-product-passport-banner-enabled'];
    }
    return false;
};

/**
 * @param {} state
 */
// Get Espot
export const getEspotById = (state, id) => {
    if (state && state.entities && state.entities.espots) {
        let espot = state.entities.espots.byId[id];
        if (!espot) {
            const arrEspotName = Object.keys(state.entities.espots.byId).filter(((espotId) => (espotId.indexOf(id) >= 0)));
            const [espotName] = arrEspotName;
            espot = state.entities.espots.byId[espotName] || null;
        }
        return espot;
    }
    return null;
};

export const getCdnImagePath = (state) => {
    const brandDetails = getBrand(state) || '';
    return `https://cdn1.${brandDetails['domain-name']}.com/wcsstore/${brandDetails.identifier}/images`;
};

export const getProductsById = function getProductsById(state) {
    if (state && state.catalog && state.catalog.products && state.catalog.products.byId) {
        return state.catalog.products.byId;
    }
    return null;
};

export const getSelectedProductSku = function getSelectedProductSku(state) {
    if (state && state.ui && state.ui.pdpCart && state.ui.pdpCart.selectedSKUProduct) {
        return state.ui.pdpCart.selectedSKUProduct;
    }
    return null;
};

// DTW - selectors
export const getDTWOptions = (state) => {
    if (state && state.mfeCheckout && state.mfeCheckout.dtw) {
        return state.mfeCheckout.dtw;
    }

    return null;
};

export const isCheckoutPage = () => {
    if (typeof window !== 'undefined') {
        if (window.location.pathname.indexOf('/checkout') >= 0 || window.location.pathname.indexOf('/add-ons') >= 0) {
            return true;
        }
    }
    return false;
};

export const getLogo = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { logos } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return logos?.primary_logo?.url;
        }
        return null;
    },
);

export const getGiftMessageConfiguration = createSelector(
    [
        getBrand,
    ],
    (currentBrand) => {
        if (currentBrand && currentBrand.code) {
            const { giftMessageConfig } = brandThemes[brandThemes[currentBrand.code] ? currentBrand.code : '18F'];
            return giftMessageConfig;
        }

        return {};
    },
);

// Checkout Food Supported Payment Method
export const getSupportedPaymentMethods = createSelector(
    [getFlags, getApplePayStatus],
    (flags, applePayStatus) => {
        const paymentMethods = ['CreditCard'];

        // Paypal Enabled
        if (flags['is-paypal-braintree-enabled']) {
            paymentMethods.push('PayPal');
        }

        // Chase Pay Enabled
        if (flags['is-chasepay-enabled']) {
            paymentMethods.push('ChasePay');
        }

        // Apple Pay Enabled
        if (flags['is-apple-pay-enabled-checkout'] && applePayStatus === 1) {
            paymentMethods.push('ApplePay');
        }

        // Klarna Enabled
        if (flags['is-klarna-payment-enabled']) {
            paymentMethods.push('Klarna');
        }

        // Paze Enabled
        if (flags['is-paze-payment-enabled']) {
            paymentMethods.push('Paze');
        }

        return paymentMethods;
    },
);

export const getIfGiftItemHaveDeliveryAddresssAndDate = (state) => {
    const hasAddress = getIsDeliveryAddressFilledForAllItems(state);
    const hasGiftMessageAndDate = isDeliveryMessageAndDateFilledForAllItems(state);

    if (hasAddress && hasGiftMessageAndDate) {
        return true;
    }
    return false;
};

// Pmall Personalization
export const getPmallSummaryInfo = (state) => state.common.pmallPersonalization || {};

// Passport Bundle
export const getPassportBundleData = (state) => state?.passport?.passportBundle;

export const getPassportBundleCollectionData = (state) => state?.passport?.passportBundleCollection;

// Passport Campaign Data
export const getPassportCampaignData = (state) => state?.passport?.passportCampaign;

export const getPassportSignInData = (state) => state?.passport?.passportSignIn;

// Passport Side Bar Status
export const getPassportSideBarStatus = (state) => state?.passport?.passportSideBarStatus;

export const getPassportData = (state) => state?.passport?.passportData;

export const getPassportTncContentMarkUp = (state) => state?.passport?.tncContent;

export const getPassportBannerStatus = (state) => {
    const paymentMethod = getPaymentMethod(state);
    const allowedPaymentMethods = getPaymentMethodToPurchasePassport();
    if (allowedPaymentMethods.includes(paymentMethod?.id)) {
        return true;
    }
    return false;
};

export const getStatusOfPassportApplyRmGC = (state) => state?.passport?.showPassportConsentToRmGC;

export const getPassportProcessStatus = (state) => state?.passport?.passportProcess;

export const getIsPassportCapPriceReached = (state) => {
    const shippingPrice = getOrderTotalShipping(state);
    const passportSubscriptionStatus = getPassportSubscriptionStatus(state);
    const brandDetails = getBrand(state) || '';
    const passportItemPrice = brandDetails['passport-item-price'] || 0;
    if (shippingPrice && passportItemPrice && (Number(shippingPrice) > Number(passportItemPrice)) && !passportSubscriptionStatus) {
        return true;
    }
    return false;
};

export const dynamicPassportCharge = (state) => state?.mfeCheckout?.passport?.dynamicPassportCharge;

export const getPassportError = (state) => state?.passport?.error;

export const getPassportLoader = (state) => state?.passport?.loader;

export const getPassportABData = (state) => state?.passport?.passportABData;

export const getDisplayAddExtraItemLink = (state) => {
    const flags = getFeatureFlags(state);
    const cartItems = getOrderItemExcludePassportAndDonation(state);
    let displayAddExtraItemLink = false;

    if (!flags['is-add-extra-item-link-enabled']) {
        return false;
    }

    cartItems.forEach((items) => (
        items.cartItems.forEach(
            (itemDetails) => {
                const isInternationalProduct = ['USA', 'US', 'CAN', 'CA'].includes(itemDetails?.deliveryInfo?.countryCode || '');
                const productType = itemDetails?.product?.productType || '';
                const noAddons = (Object.keys(itemDetails?.addons)?.length === 0);
                const isSympathyProduct = itemDetails?.product?.sympathyValue;

                if (noAddons
                    && productType === 'FPT'
                    && !isSympathyProduct
                    && !isInternationalProduct
                    && !displayAddExtraItemLink) {
                    displayAddExtraItemLink = true;
                }
            },
        )
    ));

    return displayAddExtraItemLink;
};

export const getCCOPayAsYouGoPaymentForm = (state) => {
    const orderItemsList = getOrderContainsSubscriptionItem(state);
    let displayPaymentForm = false;

    if (Array.isArray(orderItemsList)) {
        orderItemsList.forEach((recipients) => {
            const eachRecipientsOrder = recipients.cartItems;
            if (Array.isArray(eachRecipientsOrder)) {
                eachRecipientsOrder.forEach((product) => {
                    const subscriptionType = product?.subscription?.type;
                    if (subscriptionType?.toLowerCase() === 'monthonly') {
                        displayPaymentForm = true;
                    }
                });
            }
        });
    }
    return displayPaymentForm;
};

export const getCCOPayupFrontClubPaymentForm = (state) => {
    const orderItemsList = getOrderContainsSubscriptionItem(state);
    let displayPaymentForm = false;

    if (Array.isArray(orderItemsList)) {
        orderItemsList.forEach((recipients) => {
            const eachRecipientsOrder = recipients.cartItems;
            if (Array.isArray(eachRecipientsOrder)) {
                eachRecipientsOrder.forEach((product) => {
                    const subscriptionType = product?.subscription?.type;
                    if (subscriptionType?.toLowerCase() === 'monthonlypayfull') {
                        displayPaymentForm = true;
                    }
                });
            }
        });
    }
    return displayPaymentForm;
};
